// extracted by mini-css-extract-plugin
export default {"search-warning":"search-warning---I4FJX"};